import React from 'react'
import Select       from './select'

import { withRouter }   from 'react-router-dom'

export default withRouter class StateFilter extends Select
  @defaultProps:
    placeholder:  'All States'
    label:        'State'
    name:         'state'

  value: ->
    @props.location.state?.filters?["#{@props.name}"] or []
